<template>
    <div class="orderAdmin spackage padding-20 bgc box-shadow">
        <div class="head">
            <div class="flex right">
                <el-date-picker v-model="times" type="datetimerange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd"  class="item" style="width: 250px"></el-date-picker>
                <el-select v-model="apidata.orderstatus" class="select item ">
                    <el-option v-for="item in status" :key="item.key" :label="item.label" :value="item.key"></el-option>
                </el-select>
                <el-input v-model="apidata.username" placeholder="请输入用户名称" class="input item"></el-input>
                <el-input v-model="apidata.assname" placeholder="请输入社群名称" class="input item"></el-input>
                <el-input v-model="apidata.eventname" placeholder="请输入活动名称" class="input item"></el-input>
                <el-button type="primary" @click="search" class="item">搜索</el-button>
                <el-button class="item" @click="dcOrder">导出订单</el-button>
            </div>
       </div>
       <el-table rel="singleTable" :data="tableInfo">
            <el-table-column label="订单号" property='orderno' width="150" align="left">
                  <!-- <template slot-scope="scope"> -->
                        <!-- {{ (scope.$index + 1 ) + ((apidata.page - 1) * 10) }} -->
                    <!-- </template> -->
            </el-table-column>

            <el-table-column label="用户名称" align="center" width="150">
                 <template slot-scope="scope">
                     <div class="flex">
                         <img :src="scope.row.customericonurl" alt="uri">
                         <p class="one-title" style="line-height: 50px">{{ scope.row.customername }}</p>
                     </div>
                   
                </template>
            </el-table-column>
            <el-table-column label="社群名称" align="center">
                <template slot-scope="scope">
                    <p class="one-title">{{ scope.row.assname }}</p>
                </template>
            </el-table-column>
             <el-table-column label="活动名称" align="center">
                <template slot-scope="scope">
                    <p class="sub-title">{{ scope.row.eventname }}</p>
                </template>
            </el-table-column>
           
             <el-table-column property="productcount" label="商品数" width="80" align="center"></el-table-column>
             <el-table-column property="orderprice" label="订单金额" width="90" align="center"></el-table-column>
             <el-table-column property="ordertime" label="订单时间" width="160" align="center"></el-table-column>

             <el-table-column label="订单状态" width="80" align="center">
                 <template slot-scope="scope">
                     <p :class="{'color-1': true, 'color-2': scope.row.orderstatustext == '已完成', 'color-3': scope.row.orderstatustext == '待完成'}">{{scope.row.orderstatustext}}</p>
                    <!-- <p style="color: #E6A23C" v-if="scope.row.orderstatus == 9">待完成</p> -->
                    <!-- <p style="color: #67C23A" v-if="scope.row.orderstatus == 30">已完成</p> -->
                    <!-- <p style="color: #909399" v-if="scope.row.orderstatus == 100">已取消</p> -->
                 </template>
             </el-table-column>
             <el-table-column label="操作" align="right" width="80">
                 <template slot-scope="scope">
                    <div class="position">
                        <p @click="goto('OrderDetails',scope.row.orderno)">详情</p>
                        <!-- customerinnerid -->
                    </div>
                 </template>
             </el-table-column>
        </el-table>

        <el-pagination background layout="prev, pager, next" :total="totalPage" @current-change="fPage"></el-pagination>
    </div>
</template>

<script>
import fecha from 'element-ui/src/utils/date'
import { downloadImage} from 'common/js/tools'
import { mapActions} from 'vuex' // 引入 vuex 组件
import $ from 'jquery'
import CopyActive from './components/CopyActive'
import {getEventOrderList, getEventOrderExportInfo, updateEventByStatus, } from 'api/cPurchaseApi'
import {dateFormat} from 'common/js/tools'
    export default {
        name: "OrderAdmin",
        data() {
           return {
              tableInfo: [],    //表单数据
              status: [{key: '', label: '全部状态'},{key: 9, label: '待完成'},{key: 30, label: '已完成'},{key: 100, label: '已取消'}], // 状态位
              totalPage: 0,    //数据条数
              currentPage: 1, // 当前页
              times: '', // 搜索时间
              apidata: {
                orderstatus: '',     // 状态
                eventname: '',      // 活动名称
                assname: '',	// 社群名称
                username: '',  // 用户名称
                begintime: '',	// 开始时间
                endtime: '',	// 结束时间
                page: '',       // 当前页数
                pageSize: 10    // 每页展示条数
              }
          }
        },
        mounted() {
            this.activelist(1)
        },
        methods: {
            activelist(page) {  // 活动列表
                this.apidata.page = page    // 取得页数
                this.setLoading(true)

                getEventOrderList({
                    data: this.apidata,
                    success: data => {

                        this.tableInfo = data.data.content
                        this.totalPage = data.data.pageinfo.rowCount

                        console.log(data)
                        this.setLoading(false)
                    },
                    error: data => {
                        this.setLoading(false)
                        this.$message.error(data.msg)
                    }   
                })
            },
            dcOrder() { // 导出订单
                this.setLoading(true)
                getEventOrderExportInfo({
                    data: this.apidata,
                    success: data => {
                        this.setLoading(false)
                        this.exportTips = false
                        let blob = new Blob([data], {type: 'application/vnd.ms-excel'})
                        let fileName = '订单管理' + dateFormat(new Date()) + '.xls'
                        if (window.navigator.msSaveOrOpenBlob) {
                            navigator.msSaveBlob(blob, fileName)
                        } else {
                            var link = document.createElement('a')
                            link.href = window.URL.createObjectURL(blob)
                            link.download = fileName
                            link.click() // 释放内存
                            window.URL.revokeObjectURL(link.href)
                        }
                        this.$message.success('导出成功')
                    },
                    error: data => {
                        this.setLoading(false)
                        this.$message.error(data.msg)
                    }   
                })
            },
            search() {  // 搜索
                if (this.times !== null && this.times[0]) {
                    this.apidata.begintime = fecha.format(new Date(this.times[0]), 'yyyy-MM-dd')
                    this.apidata.endtime = fecha.format(new Date(this.times[1]), 'yyyy-MM-dd')
                } else {
                    this.apidata.begintime = this.apidata.endtime  = ''
                }


                this.activelist(1) 
            },  
            fPage(){    // 分页
                let clickPage = $(".el-pagination .active").html()
                // console.log($('clickPage',$(".el-pagination .active").html()))
                this.activelist(clickPage)
            },
            goto(name, orderno) {    // 前往其他页面
                this.$router.push({name: name, query: {orderno: orderno}})
            },
            ...mapActions([
                'setLoading'
            ])
        },
        filters: {},
        watch: {},
        computed: {},
        components: {}
    }
</script>

<style lang="scss" type="text/scss">
.orderAdmin {
    .one-title {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
    .sub-title {
         display: -webkit-box;
         display: -webkit-inline-box;
        -webkit-line-clamp: 2;
        line-clamp: 2;
        -webkit-box-orient: vertical;
        -moz-box-orient: vertical;
        -ms-box-orient: vertical;
        box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    .el-input__icon {
        line-height: normal;
    }
    .head {
        margin-bottom: 30px;
    }
    .color-1 {
        color: #909399
    }
    .color-2 {
        color: #67C23A
    }
    .color-3 {
        color: #E6A23C
    }
    .position,
    .head,
    .flex {
        display: flex;
        flex-wrap: nowrap;
        -ms-flex-wrap: nowrap;
        width: 100%;
        img {
            margin-right: 10px;
            width: 50px;
            height: 50px;
            border-radius: 50%;
        }
    }
        .flex.left {
            align-content: flex-start;
        }
        .flex.right {
            align-content: flex-end;
        }

        .head {
            .select {
                width: 108px;
            }
            .input {
                width: 220px;
            }
            .item {
                margin-left: 15px
            }
        }
        .el-pagination {
            margin-top: 20px;
            text-align: center;
        }

        .position {
            color: #439FFE;
            width: auto;
            float: right;

            p {
                margin: 0 5px;
                color: #439FFE;
                cursor: pointer;
            }
        }
}
    
</style>